import ComplianceManagerUI from "./ui";
export default ComplianceManagerUI;